export default __webpack_public_path__ + "2b8f9f3238fbd3e6dfd1a320c0a57ea4.png";